import React, { useContext, useState, useEffect } from "react";

import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { playerStoreContext } from "lib/player_store";
import introText from "./introText";

const Intro = () => {
  const store = useContext(playerStoreContext);
  const useStyles = makeStyles((_theme) => ({
    alert: {
      background: "linear-gradient(#ccd8f1, #e7edf7)",
      borderRadius: "0.5em",
      boxShadow:
        "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
      "& .MuiAlert-action": {
        alignItems: "normal",
      },
    },
  }));

  const classes = useStyles();
  const {
    songInfo: { song, session_plays, spc, station_type, stype },
    landingArtistNotFound,
    user_id,
  } = store;

  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    //    console.log("session_plays", session_plays, "spc", spc);
    if (spc > 4) {
      setOpen(false);
    }

    if (spc > 5 || session_plays != spc || landingArtistNotFound) {
      return;
    }

    if (user_id == 0 && spc == 5) {
      store.setSignUpOpen(true);
      return;
    }

    const c = introText({
      spc: spc,
      station_type: station_type,
      stype: stype,
      user_id: user_id,
      signUpOpen: () => {
        store.setSignUpOpen(true);
        handleClose();
      },
    });

    let timerId1; //, timerId2;

    if (c) {
      setText(c);
      timerId1 = setTimeout(() => {
        setOpen(true);
      }, 2500);
      // timerId2 = setTimeout(() => {
      //   setOpen(false);
      // }, 15000);
    }

    return () => {
      clearTimeout(timerId1);
      // clearTimeout(timerId2);
    };
  }, [song]);

  const handleClose = () => {
    setText("");
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      onClose={handleClose}
    >
      <Alert
        className={classes.alert}
        id="songpicking-intro"
        severity="info"
        action={
          <FontAwesomeIcon
            icon={["fa", "times"]}
            size="lg"
            className="icon-action"
            onClick={handleClose}
          />
        }
      >
        {text}
      </Alert>
    </Snackbar>
  );
};

export default Intro;
